import React from "react";
import SentencePart from "../SentencePart";
import PromoPart from "../PromoPart";
import SpecialConditionsPart from "../SpecialConditionsPart";
import FooterPart from "../FooterPart";

const BridgeCapitalPage = ({ companyName }) => (
  <div>
    <SentencePart companyName={companyName} />
    <PromoPart />
    <SpecialConditionsPart />
    <FooterPart />
  </div>
);

export default BridgeCapitalPage;
